app.service('productDetailsModal', function (cartManager, modal, loading, pageConfig, html,
	productDetailsGallery, basketAnalytics, toCartError) {
	var params = {
		productId: false,
		productPlu: false,
		parentId: false,
		openFrom: false,
		openAsInnerModal: false,
		callbackAdded: function () { },
		productDetailsModalOpen: function () { },
		productDetailsModalClose: function () { }
	}

	function add() {
		cartManager.simpleAddProduct({
			productId: params.productId,
			addedFrom: 'CART_EDIT',
		}, params.callbackAdded,
			function (json) {
				const cartErrorData = {
					productId: params.parentPlu,
					productStatus: 'new',
					paymentType: basketAnalytics.paymentType(),
					errorMessage: json.notPossibleAddToCartReason || 'other',
					callFromElement: 'fancybox',
					productType: 'akc',
					isOperatorMode: pageConfig.getData('order').isOperatorMode
				}
				toCartError.sendEventAddToCartError(cartErrorData);
			}
		);
	}
	function setAddToCartButton(data) {
		const text = data.isAdded ? 'Dodany do koszyka' : 'Dodaj do koszyka';
		const disabled = data.isAdded ? true : false;
		const $addToCartButton = params.openAsInnerModal ? $('#' + params.openAsInnerModal + ' .js-add-product-from-details') : $('#modal-product-details .js-add-product-from-details');
		$addToCartButton.text(text).prop('disabled', disabled)
		data.isAdded ? $addToCartButton.addClass('added') : $addToCartButton.removeClass('added');
	}

	function loadAccessoryDetails() {
		const isNewAccessories = html.has('new-accessories'); // TODO KOSZYK: do poprawy warunkowanie szczegółów akcesoriów
		loading.start();
		$.ajax({
			url: '/web-cached/product-detail/product-details-box.ltr',
			data: {
				productId: params.productId
			},
			success: function (result) {
				loading.stop();
				const $htmlContent = $('<div>' + result + '</div>').find(isNewAccessories ? '#modal-product-details-box-new' : '#modal-product-details-box');
				if (params.openAsInnerModal) {
					const $innerModal = $('#' + params.openAsInnerModal);
					if ($innerModal.length) {
						$innerModal.find('.modal-content').html($htmlContent.find('.modal-content').html());
						productDetailsGallery.init($('.product-image-gallery', $innerModal));
						if (!$innerModal.hasClass('initialized')) {
							$innerModal.on('click', '.js-add-product-from-details', function () {
								add();
							});
						}
						$innerModal.addClass('initialized');
						modal.showInternal();
						params.productDetailsModalOpen();
					}
				} else {
					modal.generate({
						id: 'modal-product-details',
						content: $htmlContent.html(),
						modifier: isNewAccessories ? ' remodal-right' : ' remodal-full-width',
						callbackOpen: function () {
							$('#modal-product-details .js-add-product-from-details').on('click', function () {
								add();
							});
							if (isNewAccessories) {
								params.productDetailsModalOpen();
								productDetailsGallery.init($('#modal-product-details .product-image-gallery'));
							}
						},
						callbackClose: function () {
							params.productDetailsModalClose();
						},

					});
				}
				UA.interaction('Koszyk - K1', 'Warstwa szczegółów produktu', 'Wyświetlenie');
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd pobierania danych o akcesorium');
			}
		});
	}
	function open(data) {
		params.productId = data.productId ? data.productId : false;
		params.productPlu = data.productPlu ? data.productPlu : false;
		params.openFrom = data.openFrom ? data.openFrom : false;
		params.parentId = data.parentId ? data.parentId : false;
		params.openAsInnerModal = data.openAsInnerModal ? data.openAsInnerModal : false;
		const basket = pageConfig.getData('basket');
		var parent = basket.items.filter(function (e) {
			return e.id == params.parentId;
		});
		params.parentPlu = parent.length ? parent[0].plu : '';

		params.callbackAdded = data.callbackAdded ? data.callbackAdded : function () { };
		params.productDetailsModalOpen = data.productDetailsModalOpen ? data.productDetailsModalOpen : function () { };
		params.productDetailsModalClose = data.productDetailsModalClose ? data.productDetailsModalClose : function () { };
		if (params.productId) {
			loadAccessoryDetails();
		}
	}
	return {
		open,
		setAddToCartButton
	};
});
